import angular from 'angular';

import styles from './styles.less';

import routes from './routes';

import template from './template.html'
import controller from './controller'

export default angular.module('app.main.panel.module.zones', [])
	.config(routes)
	.component('zones', {
		template: template,
		controller: controller,
		controllerAs: 'ctrl',
		bindings: {
			config: '<',
			status: '<'
			//onUpdate: '&'
		}
	})
	.name;


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/zones.component/index.js
 **/